// extracted by mini-css-extract-plugin
module.exports =  {"backButton":"wSHxSK9fO6u8XVDciCJl"};